import React from 'react'
import s from './Button.module.scss'

export default function Button({
	type = 'button',
	variant = 'primary', // primary | secondary | ghost | icon | light | light_purple
	size = 'md', // md | sm
	disabled = false,
	onClick,
	leftIcon,
	rightIcon,
	children,
	className = '',
	classNameInner = '',
	ariaLabel,
	typeIconHover = 'fill',
	textSize = null,
}) {
	const classes = [
		s.btn,
		s[`variant_${variant}`],
		s[`size_${size}`],
		s[`type_icon_${typeIconHover}`],
		disabled ? s.disabled : '',
		className,
	]
		.filter(Boolean)
		.join(' ')

	return (
		<button
			type={type}
			className={classes}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
		>
			<div className={`${s.inner} ${classNameInner}`}>
				{leftIcon && <span className={`${s.icon}`}>{leftIcon}</span>}
				{children && (
					<span
						className={`${variant === 'icon' ? s.icon : s.text}`}
						style={textSize && { fontSize: textSize }}
					>
						{children}
					</span>
				)}
				{rightIcon && <span className={s.icon}>{rightIcon}</span>}
			</div>
		</button>
	)
}
